// Файл: src/components/RoleRoute.js
// Страница для тех, кому allow(user) разрешает (см. utils/roles.js); остальных — на главную.
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RoleRoute = ({ allow, children }) => {
  const { user } = useAuth();
  return user && allow(user) ? children : <Navigate to="/dashboard" />;
};

export default RoleRoute;
